import React, { Component } from "react";

class QPlanPage extends Component {
  render() {
    return <div>Hello QPlanPage!</div>;
  }
}

export default QPlanPage;
